import { ApplicationState } from '../../types';

export const isExtended = (id: string) => ({ collapse }: ApplicationState) =>
  collapse.extendList.some(item => {
    const req = new RegExp(`^${id}`);
    return req.test(item);
  });
